// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"jC5pI","spinner":"dpkiS"};